import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { browserTracingIntegration, init } from '@sentry/angular';
import '@gamelearn/skeletor/dist/esm/index';

// eslint-disable-next-line
console.log('Gamelearn Admin', environment.version);

if (environment.sentry.show) {
  init({
    dsn: environment.sentry.dsn,
    environment: environment.environment,
    integrations: [browserTracingIntegration()],
    tracesSampleRate: 1,
    // FIXME Instead of ignoring me
    ignoreErrors: [
      "TypeError: Cannot read property '__zone_symbol__addEventListener' of null",
      "Error: ExpressionChangedAfterItHasBeenCheckedError: Expression has changed after it was checked. Previous value: 'ng-valid: false'. Current value: 'ng-valid: true'.",
      "Error: ExpressionChangedAfterItHasBeenCheckedError: Expression has changed after it was checked. Previous value: 'ng-valid: true'. Current value: 'ng-valid: false'."
    ]
  });
}

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));

function toggleTranslations(lang) {
  const debugLang = sessionStorage.getItem('debug_lang');

  if (debugLang && !lang) {
    console.info('㊗️㊗️㊗️ Exiting translations debug mode ㊗️㊗️㊗️');
    sessionStorage.removeItem('debug_lang');
  } else {
    lang = lang || 'labels';
    console.info('㊗️㊗️㊗️ Entering translations debug mode with lang: ' + lang + ' ㊗️㊗️㊗️');
    sessionStorage.setItem('debug_lang', lang);
  }
  location.reload();
}

window['toggleTranslations'] = toggleTranslations;
